export default __webpack_public_path__ + "static/small-image-richinstead-1-c0c63dd98627fcac88f111cc4146bf6d.png";